import React, { ChangeEvent } from 'react';
import Form from '../../../components/molecules/Form/Form';
import IForm from '../../../types/IForm';
import { RefreshCallback } from '../../../_lib/FetchContainer';
import { FormContext, FormUtils } from '../../../components/molecules/Form';
import FormsRow from '../../../components/molecules/Form/components/FormsRow/FormsRow';
import FormInput from '../../../components/molecules/Form/components/FormInput/FormInput';
import FormsComboBoxMultiSelect, {
  BREED,
} from '../../../components/molecules/Form/components/FormsComboboxMultiSelect/FormsComboBoxMultiSelect';
import FormRadioGroup, {
  FormRadioGroupOrientation,
} from '../../../components/molecules/Form/components/FormRadioGroup/FormRadioGroup';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { FormSubmitButton } from '../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { RequiredHelpPhrase } from '../../../_lib/Form2';

type PersonCollectionForm = {
  form: IForm;
  refreshBlock: RefreshCallback;
};
export function PersonCollectionForm({ form, refreshBlock }: PersonCollectionForm) {
  const { t } = useSonTranslation('PersonCollectionBlock');
  const { uuid } = useBlockContext();

  const statusMessages = {
    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t(`form.status.success`)),
    [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t(`form.status.sending`)),
    [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t(`form.status.fail`)),
    invalidValue: FormUtils.createStatusMessage(t(`form.status.invalidValue`)),
  };

  const id = `person-collection-form-${uuid}`;

  return (
    <Form id="person-collection-form" model={form} onSuccess={refreshBlock}>
      <FormContext.Consumer>
        {({ inputs, onChange, status, getStatus, submitActionEnabled }) => {
          const { title, layout, persons } = inputs;

          return (
            <>
              <RequiredHelpPhrase />
              <FormsRow>
                <FormInput
                  id={`${id}-${title.name}`}
                  labelTitle={t('form.inputs.title.label')}
                  name={title.name}
                  value={title.value}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.name, event.target.value)}
                  required={title.required}
                  maxLength={title.constraints?.maxLength}
                  pattern={title.constraints?.pattern}
                />
              </FormsRow>
              <FormsRow>
                <FormsComboBoxMultiSelect
                  breed={BREED.PersonCollection}
                  label={t('form.inputs.persons.label')}
                  idSuffix={uuid}
                  parameter={persons as any}
                />
              </FormsRow>
              {layout && layout.radioInputs && layout.radioInputs.length > 0 && (
                <FormRadioGroup
                  id={`${id}-${layout.name}`}
                  legend={t('displayLabel')}
                  orientation={FormRadioGroupOrientation.horizontal}
                  radios={layout.radioInputs as any}
                  labels={{
                    card: t(`displayOptions.card`),
                    compact: t('displayOptions.compact'),
                  }}
                  selected={layout.value}
                  onChange={onChange}
                />
              )}
              <FormSubmitButton buttonLabel={t('form.submitButton.text')} enabled={submitActionEnabled()} />
              <LiveRegion invisible={false} htmlTag="div">
                {getStatus(statusMessages, status)}
              </LiveRegion>
            </>
          );
        }}
      </FormContext.Consumer>
    </Form>
  );
}
